import { Injectable, computed, signal } from '@angular/core';

const CHAVE_ESTAGIARIO = 'eurofarma_raizes_estagiario';

/**
 * Sessão = identificação, não autenticação (CLAUDE.md §5).
 *
 * Persiste o nome do estagiário em localStorage e o expõe de forma
 * reativa (signal) para outros módulos — ex.: o EP06 usa o nome ao
 * confirmar o cadastro (campo `estagiario`).
 */
@Injectable({ providedIn: 'root' })
export class SessaoService {
  /** Sinal interno com o nome atual (null = sem sessão). */
  private readonly _estagiario = signal<string | null>(this.lerInicial());

  /** Nome do estagiário (somente leitura). */
  readonly estagiario = this._estagiario.asReadonly();

  /** true se há um estagiário identificado. */
  readonly autenticado = computed(() => this._estagiario() !== null);

  private lerInicial(): string | null {
    const valor = localStorage.getItem(CHAVE_ESTAGIARIO);
    return valor && valor.trim() ? valor : null;
  }

  /** Nome atual de forma síncrona (para guard/consumo pontual). */
  getEstagiario(): string | null {
    return this._estagiario();
  }

  /** Define e persiste o nome do estagiário. Ignora valores vazios. */
  setEstagiario(nome: string): void {
    const limpo = nome.trim();
    if (!limpo) {
      return;
    }
    localStorage.setItem(CHAVE_ESTAGIARIO, limpo);
    this._estagiario.set(limpo);
  }

  /** Encerra a sessão (botão "Sair"). */
  limpar(): void {
    localStorage.removeItem(CHAVE_ESTAGIARIO);
    this._estagiario.set(null);
  }
}
